import { transition, trigger, useAnimation } from '@angular/animations'
import { Component, EventEmitter, inject, Output } from '@angular/core'
import { ButtonComponentModule } from '@src/app/components/button/button.component.module.js'
import { ModalService } from '@src/app/core/services/modal.service.js'
import { fadeAnimation, staggerAnimation } from '@src/app/core/util/animations.util.js'
import { SharedModule } from '@src/app/shared/shared.module.js'
import { OuraRegistrationBoxComponent } from '../oura-registration-box/oura-registration-box.component.js'

@Component({
  standalone: true,
  selector: 'app-oura-entrance',
  imports: [ButtonComponentModule, SharedModule],
  templateUrl: './oura-entrance.component.html',
  styleUrls: ['./oura-entrance.component.scss'],
  animations: [
    trigger('fadeAnimation', [transition('* => *', [useAnimation(fadeAnimation)])]),
    trigger('staggerAnimation', [transition('* => *', [useAnimation(staggerAnimation)])]),
  ],
})
export class OuraEntranceComponent {
  protected modalService = inject(ModalService)

  @Output() protected ouraSelected = new EventEmitter<boolean>()

  protected async showOuraRegistrationModal(): Promise<void> {
    await this.modalService.show({
      component: OuraRegistrationBoxComponent,
      modalName: 'OuraRegistrationModal',
      sheetStyle: true,
      hideCloseButton: true,
      skipControls: true,
      skipBackdropClose: false,
      api: {
        onOuraSelected: (ownsDevice: boolean) => {
          this.ouraSelected.emit(ownsDevice)
          this.modalService.remove()
          return
        },
      },
    })
  }
}
